import { combineReducers } from "redux";
import { RootState } from "../types";
import initialization from "./initialization";
import report from "./report";

export default combineReducers<RootState>({
    initialization,
    report,
});
